import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.AirDrying.WetMass`]: wrap([`${prefix}.AirDrying.TareMass`, `${prefix}.AirDrying.TareAndWetMass`]),
  [`${prefix}.AirDrying.ConstantTareAndDryMass`]: wrap([
    `${prefix}.AirDrying.TareMass`,
    `${prefix}.AirDrying.DryMassReadings.TareAndDryMass`,
  ]),
  [`${prefix}.Combustion.AshMass`]: wrap([
    `${prefix}.OvenDrying.DryingTray.ContainerMass`,
    `${prefix}.Combustion.TareAndAshMass`,
  ]),
  // Combustion tare masses currently are only copied from oven drying masses
  [`${prefix}.Combustion.TareMass`]: wrap([`${prefix}.OvenDrying.DryingTray.ContainerMass`]),
  [`${prefix}.Combustion.TareAndOvenDryMass`]: wrap([
    `${prefix}.OvenDrying.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.Combustion.OvenDryMass`]: wrap([
    `${prefix}.OvenDrying.DryingTray.ContainerMass`,
    `${prefix}.OvenDrying.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
